import React from 'react';
import { AnimationData, AnimationTargets } from '../types';
import { Language } from '../data/translations';
import FlyingCard from './FlyingCard';

const AnimationLayer: React.FC<{
    animations: AnimationData[];
    onAnimationEnd: (id: string) => void;
    targets: AnimationTargets;
    language: Language;
}> = ({ animations, onAnimationEnd, targets, language }) => (
    <div className="fixed inset-0 pointer-events-none z-50">
        {animations.map((anim) => (
            <FlyingCard key={anim.id} animation={anim} onEnd={onAnimationEnd} targets={targets} language={language} />
        ))}
    </div>
);

export default AnimationLayer;
